/**
 * Stack of open overlays (sheets, dialogs, help). Only the topmost one reacts to Esc,
 * and page-level shortcuts are paused while any overlay is open.
 */
const stack = [];

/** Registers an overlay; returns an unregister function. `onEscape` closes it. */
export function pushOverlay(onEscape) {
  const entry = { onEscape };
  stack.push(entry);
  return () => {
    const index = stack.indexOf(entry);
    if (index !== -1) stack.splice(index, 1);
  };
}

export function hasOpenOverlay() {
  return stack.length > 0;
}

function topOverlay() {
  return stack[stack.length - 1] || null;
}

// One global Esc listener: closes only the topmost overlay
if (typeof window !== "undefined") {
  window.addEventListener("keydown", (e) => {
    if (e.key !== "Escape" || e.defaultPrevented) return;
    const top = topOverlay();
    if (!top) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    top.onEscape?.();
  }, true);
}
